/**
 * The job order serial number: the number on the paper job order handed to the
 * doctor. The lab's request of 17 October 2026, item 7: an optional field,
 * "Job order serial number", whose helper says it is "the job order on papers
 * handed to doctors".
 *
 * Free text, trimmed, as long as an old job order number may be. The API's
 * SerialNumbers, in the same words.
 */
export const SERIAL_NUMBER_MAX = 32;

export const SERIAL_NUMBER_REFUSAL = {
  tooLong: `Keep the job order serial number to ${SERIAL_NUMBER_MAX} characters.`,
} as const;

/** The number as it is kept: trimmed, and null when nothing is left. */
export function cleanSerialNumber(value: string | null | undefined): string | null {
  const trimmed = (value ?? '').trim();
  return trimmed === '' ? null : trimmed;
}

/** Why a typed number cannot be kept, or null when it can. */
export function serialNumberRefusal(value: string | null | undefined): string | null {
  const clean = cleanSerialNumber(value);
  return clean !== null && clean.length > SERIAL_NUMBER_MAX ? SERIAL_NUMBER_REFUSAL.tooLong : null;
}
